var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDorms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-bed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "829") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 5.000000)",
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.031,2.016 L15.031,3.031 L1.938,3.031 L1.938,0.078 L0.009,0.078 L0.009,3.031 L0.009,5.246 L0.009,5.971 L1.938,5.971 L1.938,4.938 L15.031,4.938 L15.031,5.971 L15.969,5.971 L15.969,2.016 L15.031,2.016 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.985,
    cy: 0.97,
    rx: 0.985,
    ry: 0.97,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.991,1.998 L6.013,1.998 L6.013,1.132 C6.013,0.534 6.656,0.049 7.447,0.049 L12.556,0.049 C13.349,0.049 13.991,0.534 13.991,1.132 L13.991,1.998 L13.991,1.998 Z",
    className: "si-glyph-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDorms);
export default __webpack_public_path__ + "static/media/dorms.f2f4d9d20177880fa0f2c73f3edb7f54.svg";
export { ForwardRef as ReactComponent };